'use strict';

//external
import React from 'external/react';
import PropTypes from 'external/prop-types';
import { Button, Col, FormControl, FormGroup } from 'external/react-bootstrap';
import Icon from './Icon';

/**
 * List for the left-hand side master-detail-widget
 * @param children
 * @param searchFunc function
 * @param createClick function
 * @param refreshClick function
 * @param searchValue Passed from state of parent component
 */
const FliwasObjectMasterDetailList = ({ children, searchFunc, createClick, searchValue, refreshClick }) => {

    return (
        <Col lg={3} md={12} sm={12} xs={12} className="nopadding">
            <div className="padding-box">
                <div className="d-flex">
                    {createClick && <div className="margin-bottom">
                        <Button title="Erstellen"
                                variant="primary"
                                onClick={createClick}>
                            Erstellen
                        </Button>
                    </div>}

                    {
                        refreshClick &&
                        <div className="margin-bottom ml-1">
                            <Button title="Neu laden"
                                    variant="primary icon-small"
                                    onClick={refreshClick}>
                                <Icon name="loader"/>
                            </Button>
                        </div>
                    }
                </div>

                {searchFunc && <FormGroup controlId="formControlsFrbSearch">
                    <FormControl type="text"
                                 value={searchValue}
                                 placeholder="Nach Namen suchen"
                                 onChange={searchFunc}/>
                </FormGroup>}
                {children}
            </div>
        </Col>
    );
};

FliwasObjectMasterDetailList.propTypes = {
    children: PropTypes.object.isRequired,
    createClick: PropTypes.func,
    searchFunc: PropTypes.func,
    searchValue: PropTypes.string,
    refreshClick: PropTypes.func,
};

export default FliwasObjectMasterDetailList;



// WEBPACK FOOTER //
// ./js/components/FliwasObjectMasterDetailList.jsx